import { render, staticRenderFns } from "./addProtectedContent.vue?vue&type=template&id=15aacaf2"
import script from "./addProtectedContent.vue?vue&type=script&lang=js"
export * from "./addProtectedContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports